import angular from 'angular'
import routers from './routers.js'
import parameterConfigurationCtrl from './parameterConfigurationCtrl.js'
import parameterConfigurationEditCtrl from './parameterConfigurationEditCtrl'
import popUpEmployeCtrl from './popUpEmployeCtrl'

export default angular
    .module('declaration.personalIncomeTax.parameterConfiguration', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('parameterConfigurationCtrl', parameterConfigurationCtrl)
    .controller('parameterConfigurationEditCtrl', parameterConfigurationEditCtrl)
    .controller('popUpEmployeCtrl', popUpEmployeCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/index.js